import { useTranslation } from 'react-i18next';

export const useTqEnAppealConsultationStatsLabels = (): Record<string, string> => {
  const { t } = useTranslation('tqen_appeal_consultation_stats_annual_report');

  const tqEnAppealConsultationStatsLabels: Record<string, string> = {
    totalEiaConsultationsReceived: t(
      'tqen_total_eia_consultations_received',
      'Total number of Appeal consultations received'
    ),
    averageDaysTakenToRespondToEiaConsultations: t(
      'tqen_average_days_taken_to_respond_to_eia_consultations',
      'Average number of days taken to respond to Appeal consultations'
    ),
  };

  return tqEnAppealConsultationStatsLabels;
};
